import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './TsAuctionBid.scss';
import { getTsBidDetailsData } from '../../reducers/tsAuctionReducer';
import {
  bidOnAuction,
  fetchBidDetailsById,
} from '../../actions/actionCreators/tsAuctionActionCreators';
import { auctionBidResetMaster } from '../../actions/pureActions/auctionActions';
import { QuestionCircleOutlined, SelectOutlined } from '@ant-design/icons';
import { Button, Checkbox, message, Spin, Tooltip } from 'antd';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import validateSchema from './ValidateSchema';
import { translateTsFuelTypeClassificator } from '../../utils/translateHelpers';
import { TableActions, TableRowActions } from '../../components';
import { Form, Field } from 'react-final-form';
import { NumberField } from '../../atoms';
import { FORM_TS_AUCTION_BID } from '../../constants/formKeys';
import FormStateToRedux from '../FormStateToRedux';
import { formTsAuctionBidFields } from '../../constants/forms/formTsAuctionBidFields';
import dayjs from '../../utils/dayjs';
import { fuelType } from '../../constants/classificators';
import { calculateTransactionCost } from '../../components/TsAuctionSearchTable/TsAuctionSearchTableColumns';
import { getInfoModal } from '../../pages/TsAuctionDetailsView/TsAdditionalInfoModal';

export class TsAuctionBid extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    selectedRow: PropTypes.object.isRequired,
    hideBidModal: PropTypes.func.isRequired,
    refreshTable: PropTypes.func.isRequired,
    handleView: PropTypes.func,
    onSuccess: PropTypes.func,
    bidOnAuction: PropTypes.func.isRequired,
    fetchTsBidDetails: PropTypes.func.isRequired,
    tsBidDetails: PropTypes.object,
    resetMaster: PropTypes.func.isRequired,
  };

  state = {
    isAdditionalInfoVisible: false,
    agreeToConditions: false,
    agreeToAutomaticReport: false,
    agreeToManualReport: false,
    currentTime: dayjs(),
  };

  componentDidMount() {
    const { selectedRow, fetchTsBidDetails } = this.props;
    fetchTsBidDetails(selectedRow.id);
  }

  componentWillUnmount() {
    const { resetMaster } = this.props;
    resetMaster();
  }

  onSubmit = async (values) => {
    const { selectedRow, t, hideBidModal, refreshTable } = this.props;
    const { agreeToAutomaticReport, agreeToManualReport } = this.state;

    const res = await this.props.bidOnAuction({
      auctionId: selectedRow.id,
      unitPrice: values.unitPrice,
      agreeToAutomaticReport,
      agreeToManualReport,
    });

    if (!res?.error) {
      message.success(t('bidModal.performSuccess'));
      hideBidModal();
      refreshTable();
    }
  };

  handleView = (id) => {
    const { hideBidModal, handleView } = this.props;
    hideBidModal();
    handleView(id);
  };

  renderRow = (label, value, className = null) => (
    <div className={className}>
      <span>{label}: </span>
      <span>{value}</span>
    </div>
  );

  renderRowWithTooltip = (label, value, tooltipTitle) => (
    <div>
      <span>
        {label}&nbsp;
        <Tooltip title={tooltipTitle}>
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
      <span>: </span>
      <span>{value}</span>
    </div>
  );

  renderCheckboxWithTooltip = (label, tooltipTitle) => (
    <>
      <span>{label}</span>
      <span style={{ paddingLeft: 4 }}>
        <Tooltip title={tooltipTitle}>
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
    </>
  );

  handlePriceChange = (e, currentBid, bidStep) => {
    const value =
      this._form?.getState()?.values?.[formTsAuctionBidFields.UNIT_PRICE];
    if (value && value > currentBid) {
      e.preventDefault(); // Prevent auto updating field value

      const roundedValue = Math.round((value - currentBid) / bidStep) * bidStep;
      this._form?.change(
        formTsAuctionBidFields.UNIT_PRICE,
        roundedValue + currentBid
      );
    }
  };

  render() {
    const { t, selectedRow, tsBidDetails, hideBidModal } = this.props;
    const {
      agreeToConditions,
      agreeToAutomaticReport,
      agreeToManualReport,
      isAdditionalInfoVisible,
      currentTime,
    } = this.state;

    if (tsBidDetails == null) return <Spin />;
    const data = tsBidDetails.toJS();

    const isKhg = data.fuelType === fuelType.KHG;
    const khg = isKhg ? 'Khg' : '';

    const validate = makeRffValidateFromLegacy(validateSchema, this.props);

    const initialUnitPrice = data.currentBid
      ? data.currentBid + data.minBidStep
      : data.minUnitPrice;

    return (
      <Form
        onSubmit={this.onSubmit}
        validate={validate}
        initialValues={{
          [formTsAuctionBidFields.UNIT_PRICE]: initialUnitPrice,
        }}
        render={({ handleSubmit, form, values }) => {
          this._form = form;
          const newUnitPrice = values[formTsAuctionBidFields.UNIT_PRICE];
          return (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_TS_AUCTION_BID} />
              {getInfoModal.call(
                this,
                isAdditionalInfoVisible,
                t('bidModal.additionalInfo'),
                data.additionalInfo
              )}

              <div className="detail-container">
                {data.highestBidder && (
                  <>
                    <div>
                      <strong>
                        {currentTime.format('DD.MM.YYYY HH:mm:ss')}{' '}
                        {t('bidModal.highestBidder')}
                      </strong>
                    </div>
                    <br />
                  </>
                )}
                <div>
                  <span>{t('bidModal.id')}: </span>
                  <a onClick={() => this.handleView(selectedRow.id)}>
                    {selectedRow.id}
                  </a>
                </div>
                {this.renderRow(t('bidModal.createdDate'), data.createdDate)}
                {this.renderRow(t('bidModal.endDate'), data.endDate)}
                <br />
                {this.renderRow(t('bidModal.sellerName'), data.sellerName)}
                {this.renderRow(t('bidModal.sellerCode'), data.sellerCode)}
                <br />
                {this.renderRow(
                  t('bidModal.fuelType'),
                  translateTsFuelTypeClassificator(data.fuelType)
                )}
                {!isKhg ? (
                  <>
                    {this.renderRow(
                      t('bidModal.naturalAmountMj'),
                      data.naturalAmountMj.toFixed(1)
                    )}
                    {this.renderRow(
                      t('bidModal.accountedAmountMj'),
                      data.accountedAmountMj.toFixed(1)
                    )}
                    {selectedRow.ghgCapacity
                      ? this.renderRow(
                          t('bidModal.ghgCapacity'),
                          selectedRow.ghgCapacity.toFixed(1)
                        )
                      : null}
                  </>
                ) : (
                  <>
                    {this.renderRow(
                      t('bidModal.ghgAmount'),
                      data.ghgAmount.toFixed(1)
                    )}
                  </>
                )}
                {this.renderRow(
                  t('bidModal.expirationDate'),
                  data.expirationDate
                )}
                <br />
                {this.renderRow(
                  t('bidModal.currentBidDate'),
                  data.currentBidDate ?? '-'
                )}
                {this.renderRowWithTooltip(
                  t('bidModal.currentUnitPrice' + khg),
                  data.currentBid ? data.currentBid.toFixed(3) : '-',
                  t('bidModal.currentUnitPriceTooltip' + khg)
                )}
                {this.renderRowWithTooltip(
                  t('bidModal.currentTransactionCost'),
                  data.currentBid
                    ? calculateTransactionCost(
                        data,
                        data.currentBid,
                        isKhg
                      ).toFixed(2)
                    : '-',
                  t('bidModal.currentTransactionCostTooltip')
                )}
                <br />
                <Field
                  disabled={data.biddingDisabled}
                  min={
                    data.currentBid
                      ? data.currentBid + data.minBidStep
                      : data.minUnitPrice
                  }
                  step={data.minBidStep}
                  precision={3}
                  name={formTsAuctionBidFields.UNIT_PRICE}
                  label={t('bidModal.newUnitPrice' + khg)}
                  tooltip={t('bidModal.unitPriceTooltip' + khg)}
                  placeholder={t('bidModal.newUnitPricePlaceholder')}
                  component={NumberField}
                  onBlur={(event) =>
                    this.handlePriceChange(
                      event,
                      data.currentBid ?? data.minUnitPrice,
                      data.minBidStep
                    )
                  }
                  isFloat
                  blurAllowed
                />
                {this.renderRowWithTooltip(
                  t('bidModal.newTransactionCost'),
                  (newUnitPrice
                    ? calculateTransactionCost(data, newUnitPrice, isKhg)
                    : 0
                  ).toFixed(2),
                  t('bidModal.newTransactionCostTooltip')
                )}
                <br />
                {this.renderRow(
                  t('bidModal.additionalInfo'),
                  <TableRowActions>
                    <Button
                      shape="circle"
                      icon={<SelectOutlined />}
                      size="small"
                      type="primary"
                      style={{ marginLeft: '8px' }}
                      title={t('bidModal.additionalInfo')}
                      onClick={() =>
                        this.setState({ isAdditionalInfoVisible: true })
                      }
                    />
                  </TableRowActions>,
                  'ant-row-flex'
                )}
                <br />
              </div>
              {!data.biddingDisabled && (
                <>
                  <Checkbox
                    onChange={(event) =>
                      this.setState({ agreeToConditions: event.target.checked })
                    }
                    checked={agreeToConditions}
                    className="mb-3"
                    style={{ marginLeft: 0 }}
                  >
                    {t('bidModal.confirmCheckbox')}
                  </Checkbox>
                  <Checkbox
                    disabled={agreeToManualReport}
                    name={formTsAuctionBidFields.AGREE_TO_AUTOMATIC_REPORT}
                    onChange={(event) => {
                      this.setState({
                        agreeToAutomaticReport: event.target.checked,
                      });
                    }}
                    checked={agreeToAutomaticReport}
                    className="mb-3"
                    style={{ marginLeft: 0 }}
                  >
                    {this.renderCheckboxWithTooltip(
                      t('bidModal.agreeToAutomaticReport'),
                      t('bidModal.agreeToAutomaticReportTooltip')
                    )}
                  </Checkbox>
                  <Checkbox
                    disabled={agreeToAutomaticReport}
                    name={formTsAuctionBidFields.AGREE_TO_MANUAL_REPORT}
                    onChange={(event) => {
                      this.setState({
                        agreeToManualReport: event.target.checked,
                      });
                    }}
                    checked={agreeToManualReport}
                    className="mb-3"
                    style={{ marginLeft: 0 }}
                  >
                    {this.renderCheckboxWithTooltip(
                      t('bidModal.agreeToManualReport'),
                      t('bidModal.agreeToManualReportTooltip')
                    )}
                  </Checkbox>
                </>
              )}
              <TableActions>
                <Button onClick={() => hideBidModal()}>
                  {t('bidModal.cancel')}
                </Button>
                {!data.biddingDisabled && (
                  <Button
                    disabled={
                      !agreeToConditions ||
                      !newUnitPrice ||
                      (!agreeToManualReport && !agreeToAutomaticReport)
                    }
                    type="primary"
                    htmlType="submit"
                    className="global-margin-left-10"
                  >
                    {t('bidModal.confirm')}
                  </Button>
                )}
              </TableActions>
            </form>
          );
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  tsBidDetails: getTsBidDetailsData(state),
});

const mapDispatchToProps = {
  bidOnAuction,
  fetchTsBidDetails: fetchBidDetailsById,
  resetMaster: auctionBidResetMaster,
};

export default connect(mapStateToProps, mapDispatchToProps)(TsAuctionBid);
